shadow$provide[127] = function(require,module,exports) {
var require$_DOT__SLASH_VRControls_DOT_js = require("./VRControls.js");

};